var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, } from "react";
import groupBy from "lodash.groupby";
import { SectionTitle, InputGroup, InputLabel, useLoaderButton, useNotificationsCtx, TNotificationType, } from "@gw/component-library";
import { useBNDataLayer } from "@gw/bn-data-layer";
import { useBNIdentity } from "@gw/bn-identity";
import { ModalContactStyled, ButtonContainer, TextAreaStyled, } from "./ModalContactStyled";
import { useUserProfileFormFields } from "../UserProfileForm/useUserProfileFormFields";
var Section;
(function (Section) {
    Section["CompanyInformation"] = "Company Information";
    Section["PersonalInformation"] = "Personal Information";
    Section["ProductInformation"] = "Product Information";
    Section["PurchasePreferences"] = "Purchase Preferences";
})(Section || (Section = {}));
var ModalContact = function (_a) {
    var modalId = _a.modalId, farmerId = _a.farmerId, closeModal = _a.closeModal;
    var _b = useState(false), success = _b[0], setSuccess = _b[1];
    var _c = useLoaderButton({}), LoaderButton = _c.LoaderButton, enableButton = _c.enableButton, disableButton = _c.disableButton, setLoadingButton = _c.setLoadingButton;
    var _d = useState(""), message = _d[0], setMessage = _d[1];
    var contactFarmer = useBNDataLayer().contactFarmer;
    var userProfile = useBNIdentity().userProfile;
    var addNotification = useNotificationsCtx().addNotification;
    var _e = useState(false), onProfileLoaded = _e[0], setOnProfileLoaded = _e[1];
    var fieldList = useUserProfileFormFields().fieldList;
    var groupBySection = groupBy(fieldList, "section");
    var formatMessageContent = function (groupBySection) {
        var updatedGroupBySection = __assign(__assign({}, groupBySection), { "Personal Information": groupBySection["Personal Information"].filter(function (item) { return item.name !== "companyAssociation"; }), "Company Information": groupBySection["Company Information"].filter(function (item) { return item.name !== "companyRevenue"; }), "Product Information": groupBySection["Product Information"].filter(function (item) {
                return item.name !== "currentlyPurchasing" &&
                    item.name !== "purchasingRegions" &&
                    item.name !== "seaweedSource";
            }) });
        var message = "";
        message += "\r\n\r\n\r\n--------------------------\r\n";
        Object.entries(updatedGroupBySection).map(function (_a) {
            var _b;
            var group = _a[0], fields = _a[1];
            if (fields.length > 0) {
                message += group + "\r\n\r\n";
                (_b = fields
                    .forEach(function (field) {
                    message += field.label + ": " + (field.value || "") + "\r\n";
                })) === null || _b === void 0 ? void 0 : _b.join("\r\n");
                message += "\r\n";
            }
        });
        setMessage(message);
    };
    useEffect(function () {
        message === "" ? disableButton() : enableButton();
    }, [message, enableButton, disableButton]);
    useEffect(function () {
        try {
            disableButton();
            var fetchUserProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, userProfile()
                                .then(function (user) {
                                fieldList.map(function (field) {
                                    var userHasPayloadKey = Object.prototype.hasOwnProperty.call(user, field.payloadKey);
                                    if (userHasPayloadKey) {
                                        field.setter(user[field.payloadKey]);
                                    }
                                });
                            })
                                .then(function () { return setOnProfileLoaded(true); })];
                        case 1:
                            _a.sent();
                            if (message !== "")
                                enableButton();
                            return [2];
                    }
                });
            }); };
            fetchUserProfile();
        }
        catch (err) {
            addNotification("There was an error when loading your profile!", TNotificationType.error);
            if (message !== "")
                enableButton();
        }
    }, []);
    useEffect(function () {
        if (!onProfileLoaded)
            formatMessageContent(groupBySection);
    }, [fieldList, onProfileLoaded]);
    var handleContactFarm = function (ev) {
        ev.preventDefault();
        if (success) {
            closeModal(modalId);
        }
        else {
            setLoadingButton();
            contactFarmer(farmerId, message)
                .then(function () {
                setSuccess(true);
                enableButton();
            })
                .catch(function () {
                addNotification("There was an error when sending your message.", TNotificationType.error);
                enableButton();
            });
        }
    };
    return (React.createElement(ModalContactStyled, { onSubmit: function (ev) { return handleContactFarm(ev); } },
        React.createElement("div", { className: "content" }, success ? (React.createElement(React.Fragment, null,
            React.createElement(SectionTitle, { className: "title divider" }, "Your message has been sent."),
            React.createElement("p", null,
                "If the farmer is interested in learning more about this opportunity, they will respond to your message via the email address you provided when you registered for Seaweed Source.",
                " "),
            React.createElement("p", null, "Thank you for supporting independent ocean farmers!"))) : (React.createElement(React.Fragment, null,
            React.createElement(SectionTitle, { className: "title divider" }, "Message Farmer"),
            React.createElement("div", { className: "message-prompt" },
                React.createElement("p", null, "Write your message here. Information from your application will be be included in your message unless you choose to edit or delete content. Providing these details sets you up for more successful connections with farmers.")),
            React.createElement(InputGroup, null,
                React.createElement(InputLabel, null, "Message"),
                React.createElement(TextAreaStyled, { name: "message", rows: 8, placeholder: "Write your message here...", value: message, onChange: function (evt) {
                        return setMessage(evt.target.value);
                    } }))))),
        React.createElement(ButtonContainer, null,
            React.createElement(LoaderButton, { className: "gtm-contact-submit submit-button" },
                React.createElement(React.Fragment, null, success ? "Close" : "Submit")))));
};
export default ModalContact;
//# sourceMappingURL=ModalContact.js.map